import React from 'react'
import { convertSKUToSlug } from "../utilities"
import useUser from "../hooks/useUser"
import { fetchFromAPI, formatCurrency } from "../utils"
import { ACTIONS } from './reducer'

export default function ProductDetailsContainer({ state, dispatch, isMountBarOnly }) {
    const { productDetails } = state

    if (!productDetails){
        return (
            <div className="jrco-configurator__messages">
                <h2>Choose next dropdown</h2>
            </div>
        )
    }

    return <ProductDetails {...{ state, dispatch, isMountBarOnly }} />
}

function ProductDetails({ state, dispatch, isMountBarOnly }) {
    const { productDetails, isProductDetailsLoading } = state
    const { isAuthenticated } = useUser()
    const [purchaseDetails, setPurchaseDetails] = React.useState([])
    const cardsToRender = []
    if (productDetails.mountBar?.length > 0) {
        cardsToRender.push(
            {key:"mountBar", label:"Mount Bar Only", productDetails:productDetails.mountBar[0]}
        )
    }
    if (!isMountBarOnly && productDetails.tineRake?.length > 0) {
        cardsToRender.push(
            {key:"tineRake", label: "Tine Rake Only", productDetails:productDetails.tineRake[0]}
        )
    }
    if (!isMountBarOnly && productDetails.mountBarWithTineRake?.length > 0) {
        cardsToRender.push(
            {key:"mountBarWithTineRake", label:"Mount Bar and Tine Rake", productDetails:productDetails.mountBarWithTineRake[0]}
        )
    }
    if (!isMountBarOnly && productDetails.mountBarWithTineRakeHD?.length > 0) {
        cardsToRender.push(
            {key:"mountBarWithTineRakeHD", label: "Mount Bar and Tine Rake HD", productDetails:productDetails.mountBarWithTineRakeHD[0]}
        )
    }

    const items = cardsToRender.map(card => card.productDetails)

    React.useEffect(() => {
        async function getManyItemPurchaseDetails(items) {
            const options = {
                method: 'POST',
                body: JSON.stringify({
                    DestinationCountry: document.getElementById('hdnShipToAddressCountry')?.value, 
                    DestinationRegion: document.getElementById('hdnShipToAddressState')?.value, 
                    DestinationPostalCode: document.getElementById('hdnShipToAddressZipCode')?.value, 
                    items: items.map(item => ({
                        sku: item.sku.trim(),
                        requestedQuantity: 1,
                        unitOfMeasure: item.uom.trim()
                    }))
                })
            }
            function onError(message) {
                const failureMessage = `
                    A data request failed resulting in an error.
        
                    Things you can try:
                    - Check your network connection
                    - Sign out and back in again
                `
        
                alert(failureMessage)
            } 
            const result = await fetchFromAPI(`/items/get-many-purchase-details`, options, onError)
            setPurchaseDetails(result.data)
            dispatch({type: ACTIONS.SET_PRODUCT_DETAILS_LOADING, payload: false})
        }
        if (isAuthenticated) {
            getManyItemPurchaseDetails(items)       
        } else {          
            dispatch({type: ACTIONS.SET_PRODUCT_DETAILS_LOADING, payload: false})
        }
    }, [isAuthenticated, dispatch, items])

    // consider moving to details component below: 
    if (isProductDetailsLoading) {
        return <div>Loading...</div>
    }


    cardsToRender.forEach(card => {
        card.purchaseDetails = purchaseDetails.find(purchaseDetail => purchaseDetail.sku === card.productDetails.sku)
    })

    const ProductDetailCard = isAuthenticated ? ProductDetailCardAuthenticated : ProductDetailCardGuest
    return cardsToRender.map(entry => <ProductDetailCard key={entry.key} label={entry.label} productDetails={entry.productDetails} purchaseDetails={entry.purchaseDetails} />)
}

function ProductDetailCardAuthenticated({ label, productDetails, purchaseDetails = {} }) {
   

    const { sku } = productDetails
    const sluggifiedSku = convertSKUToSlug(sku)
    return (
        <div className="jrco-configurator__part-container">
            <h4>{label}: <a className=" linkPri" href={`/${sluggifiedSku}`}>{sku}</a></h4> 
            <table className="jrco-configurator__table" data-mount-bar-only="@mountBarOnly">
                <thead>
                    <tr>
                        <th>Unit of Measure</th>
                        <th>Qty</th>
                        <th>MSRP</th>
                        <th>Your Cost</th>
                        <th className="jrco-configurator__add-to-cart">Add to Cart</th>
                    </tr>
                </thead>
                <tbody>
                    <tr data-product-id-uom={productDetails.productIdUom}>
                        <td>{productDetails.uom}</td>                        
                        <td><span className="jrco-configurator__quantity">1</span></td>
                        <td className="msrp">{formatCurrency(purchaseDetails.msrp)}</td>
                        <td className="dealer-price" data-sku={productDetails.sku}>
                            <span>{formatCurrency(purchaseDetails.price)}</span>
                            <a href={`/${sluggifiedSku}`} className="linkPri buy-more-save-more-link">Buy More<br />Save More</a>
                        </td>
                        <td className="jrco-configurator__add-to-cart">
                            <button data-sku={productDetails.sku} data-uom={productDetails.uom}
                                data-raw-price={productDetails.rawPrice} data-name={productDetails.name} data-brand={productDetails.brand}
                                data-product-id-uom={productDetails.productIdUom}
                                className="btnPri button--small button--full-width jrco-configurator__add-to-cart-button">
                                Add
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="5">
                            <strong className="availability-message">{purchaseDetails.availabilityMessage}</strong>                            
                        </td>                        
                    </tr>
                </tbody>
            </table>
        </div>
    )    
}

function ProductDetailCardGuest({ label, productDetails }) {
    const { sku } = productDetails
    const sluggifiedSku = convertSKUToSlug(sku)
    return (
        <div className="jrco-configurator__part-container">
            <h4>{label}: <a className=" linkPri" href={`/${sluggifiedSku}`}>{sku}</a></h4> 
            <table className="jrco-configurator__table" data-mount-bar-only="@mountBarOnly">
                <thead>
                    <tr>
                        <th>Unit of Measure</th>
                        <th>Qty</th>
                        <th>MSRP</th>
                        <th>Your Cost</th>
                        <th className="jrco-configurator__add-to-cart">Add to Cart</th>
                    </tr>
                </thead>
                <tbody>
                    <tr data-product-id-uom={productDetails.productIdUom}>
                        <td>{productDetails.uom}</td>                        
                        <td><span className="jrco-configurator__quantity">1</span></td>
                        <td></td>
                        <td></td>
                        <td className="jrco-configurator__add-to-cart">
                            <a href="/login?returnUrl=" className="btnPri button--small login-link">Sign In to Order</a>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="5">
                            <a className="linkPri" href="/dealerlocator?brand=JRCO">Find a Jrco dealer near you</a>
                        </td>                        
                    </tr>
                </tbody>
            </table>
        </div>
    )    
}